import { apiClient } from './api';
import type { DashboardResponse } from '@wooconnect/shared';

export async function getDashboard(siteId: string, refresh = false): Promise<DashboardResponse> {
  const res = await apiClient.get(`/sites/${siteId}/dashboard`, {
    params: refresh ? { refresh: 'true' } : undefined,
  });
  return res.data.data;
}

export async function getRevenueChart(siteId: string, days = 7) {
  const res = await apiClient.get(`/sites/${siteId}/analytics/revenue`, {
    params: { period: 'daily', days },
  });
  return res.data.data;
}
